import { render, staticRenderFns } from "./ModalCreateNewValue.vue?vue&type=template&id=03bf7d36&scoped=true"
import script from "./ModalCreateNewValue.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewValue.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNewValue.vue?vue&type=style&index=0&id=03bf7d36&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf7d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bf7d36')) {
      api.createRecord('03bf7d36', component.options)
    } else {
      api.reload('03bf7d36', component.options)
    }
    module.hot.accept("./ModalCreateNewValue.vue?vue&type=template&id=03bf7d36&scoped=true", function () {
      api.rerender('03bf7d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalCreateNewValue.vue"
export default component.exports